module.exports = __webpack_public_path__ + "img/places-3.5656747f.jpg";